import { createReducer, on } from '@ngrx/store';

import { setFormulaFunctions } from './formulas.actions';
import { type FormulasState } from './formulas.state';

export const initialState: FormulasState = {
  formulaFunctions: [],
};

export const reducer = createReducer(
  initialState,

  on(setFormulaFunctions, (state, { formulaFunctions }) =>
    formulaFunctions ? { ...state, formulaFunctions } : state,
  ),
);
